import TrackingContext from './TrackingContext';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackingContextWrapper = ({
  track,
  children
}) => /*#__PURE__*/_jsx(TrackingContext.Provider, {
  value: {
    track
  },
  children: children
});
export default TrackingContextWrapper;